﻿$.fn.dxCtrlWizardConfigCompteEmail = function custom_dxCtrlWizardConfigCompteEmail(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlwizardconfigcompteemail dx-ctrl");
        this.createInstance(new cdxCtrlWizardConfigCompteEmail(this, option));
    }
    return this;
}

window.cdxCtrlWizardConfigCompteEmail = function (container, option) {
    var Me = this;


    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
            dx.option(name, value);
        }
    }

    var dxWizard = null;
    if (typeof option.dataUtilisateur == 'undefined') option.dataUtilisateur = option.bddCtrl.utiCourant
    var dataCompteEmail = null
    var dataCompteEmailUtilisateur = null
    var isAbonnement = false
    function mConstruit() {
        container.empty();

        var passFirstItem = false;
        //début
        var demandeNextItemDebut = false
        var isInGetConfig = false
        var dxCtrlTxtEmail = null
        var wizardItemDebut = new cWizardItem()
        wizardItemDebut.allowScroll = false
        wizardItemDebut.itemTemplate = function (itemElement, wizard) {
            isAbonnement = false
            dataCompteEmail = option.bddCtrl.getObjet("compte_email").mGetNewData()
            dataCompteEmail.id_utilisateur = option.dataUtilisateur.id_utilisateur
            dataCompteEmailUtilisateur = option.bddCtrl.getObjet("compte_email_utilisateur").mGetNewData()
            dataCompteEmailUtilisateur.id_utilisateur = option.dataUtilisateur.id_utilisateur
            if (option.bddCtrl.getObjet(dataCompteEmailUtilisateur).objetMetier.isUnique()) dataCompteEmailUtilisateur.defaut = "1"
            itemElement.css({
                "display": "flex",
                "align-items": "center",
                "justify-content": "center",
                "text-align": "center"
            })

            var $DivInner = $("<div/>").appendTo(itemElement)
            $("<div>Saisissez l'adresse email que vous voulez rajouter dans " + parametre.nom + ".</div>").appendTo($DivInner)
            dxCtrlTxtEmail = $("<div style=''/>").appendTo($DivInner).dxCtrlTextEmail({
                labelMode: 'floating',
                label: "Adresse email",
                showClearButton: false,
                //placeholder: "Saisissez l'adresse " + String.fromCharCode(8203) + "email que vous voulez rajouter...",
                value: dataCompteEmail.adresse_email,
                maxLength: 500,
                width: 400,
                inputAttr: { autocomplete: 'test-autocomplete' },
                onValueChanged: function (e) {
                    if (e.value == null || e.value.length == 0) {
                        dataCompteEmail.adresse_email = ""
                    } else {
                        dataCompteEmail.adresse_email = e.value;
                        var compteEmail = mGetCompteEmail()
                        if (compteEmail != null && mGetCompteEmailUtilisateur() != null) {
                            mNotify("Vous utilisez déjà cette adresse email", "warning", 12000)
                            //e.component.option("value", "")
                            //dataCompteEmail.adresse_email = ""
                        } else if (compteEmail != null && mGetCompteEmailUtilisateur() == null) {
                            //le compte email existe déjà mais n'est pas lié à l'utilisateur
                            dataCompteEmail = compteEmail
                            dxWizard.mNext(true)
                        } else {
                            if (demandeNextItemDebut) dxWizard.mNext(true)
                            demandeNextItemDebut = false
                        }
                    }
                },
                onContentReady: function (e) {
                    window.setTimeout(function () { e.component.focus() }, 500)
                }
            }).dxCtrlTextEmail("instance")
        }
        wizardItemDebut.getNextItem = function () {
            return wizardItemEmailVerif
        }
        wizardItemDebut.getPreviousItem = function () { return null; }
        wizardItemDebut.isOkForNext = function () {
            var result = true
            if (dataCompteEmail.adresse_email == null || dataCompteEmail.adresse_email.length == 0) {
                mNotify("Veuillez saisir l'adresse email à rajouter", "warning", 6000)
                dxCtrlTxtEmail.element().slideDown(200, function () { dxCtrlTxtEmail.focus(); })
                result = false
            } if (mGetCompteEmail() != null && mGetCompteEmailUtilisateur() != null) {
                mNotify("Vous disposez déjà de cette adresse email", "warning", 6000)
                dxCtrlTxtEmail.element().slideDown(200, function () { dxCtrlTxtEmail.focus(); })
                result = false
            }
            return result
        }

        function mGetCompteEmail() {
            var compteEmail = option.bddCtrl.mGetArray("compte_email").filter(function (o) { return o.adresse_email == dataCompteEmail.adresse_email })[0]
            return ((typeof compteEmail == 'undefined') ? null : compteEmail)
        }
        function mGetCompteEmailUtilisateur() {
            var compteEmailUtilisateur = null;
            var compteEmail = mGetCompteEmail()
            if (compteEmail != null) {
                //l'adresse email existe déja
                compteEmailUtilisateur = option.bddCtrl.mGetArray("compte_email_utilisateur").filter(function (o) { return o.id_compte_email == compteEmail.id_compte_email && o.id_utilisateur == option.dataUtilisateur.id_utilisateur })[0]
            }
            return ((typeof compteEmailUtilisateur == 'undefined') ? null : compteEmailUtilisateur)
        }

        //email existe
        var wizardItemEmailVerif = new cWizardItem()
        wizardItemEmailVerif.allowScroll = false
        wizardItemEmailVerif.itemTemplate = function (itemElement, wizard) {
            itemElement.css({
                "display": "flex",
                "align-items": "center",
                "justify-content": "center",
                "text-align": "center"
            })

            dataCompteEmail.reception_login = ""
            dataCompteEmail.reception_serveur = ""
            dataCompteEmail.reception_port = ""
            dataCompteEmail.reception_ssl = ""
            dataCompteEmail.reception_is_imap = ""
            dataCompteEmail.reception_pwd = ""

            dataCompteEmail.envoi_serveur = ""
            dataCompteEmail.envoi_port = ""
            dataCompteEmail.envoi_ssl = ""
            dataCompteEmail.envoi_pwd = ""

            if (mGetCompteEmail() != null &&
                mGetCompteEmail().id_utilisateur == option.bddCtrl.utiCourant.id_utilisateur &&
                option.dataUtilisateur.id_utilisateur != option.bddCtrl.utiCourant.id_utilisateur) {
                //l'adresse email existe déjà et appartient à l'utilisateur connecté
                //l'utilisateur a qui on veut raccrocher l'email est un autre utilisateur que l'utilisateur connecté
                //on affiche un message pour signaler que l'on va abonner l'utilisateur à cette adresse email
                var $Div = $("<div/>").appendTo(itemElement)
                $("<div>L'adresse email <u>" + dataCompteEmail.adresse_email + "</u><br/> existe déjà dans la liste de vos emails.<br/><br/>" +
                    "Vous allez abonner l'utilisateur <b>" + option.bddCtrl.getObjet(option.dataUtilisateur).mGetLib1() + "</b> à cette adresse email.</div>").appendTo($Div)
                isAbonnement = true
                $("<div style='margin-top:20px;'/>").appendTo($Div).dxCtrlButton({
                    text: "Je confirme l'abonnement",
                    onClick: function (e) {
                        dxWizard.mNext(true)
                    }
                })
            } else {
                var dxCtrlSaisieCode = $("<div/>").appendTo(itemElement).dxCtrlSaisieCode({
                    bddCtrl: option.bddCtrl,
                    from: "Ajout adresse email environnement (dxCtrlWizardConfigCompteEmail)",
                    contentTemplateTop: function (itemElement) {
                        if (mGetCompteEmail() == null) {
                            $("<div>Pour utilisez une nouvelle adresse email,<br/>vous devez confirmer que vous avez bien accès à celle-ci.<br/>Un code a été envoyé sur <u>" + dataCompteEmail.adresse_email + "</u>.<br/>Veuillez saisir ce code.</div>").appendTo(itemElement)
                        } else {
                            isAbonnement = true
                            var dataUtiProprio = option.bddCtrl.mGetArray("utilisateur").filter(function (o) { return o.id_utilisateur == mGetCompteEmail().id_utilisateur })[0]
                            $("<div style='font-size:140%;'>L'adresse email <u>" + dataCompteEmail.adresse_email + "</u><br/>est liée à l'utilisateur <b>" + option.bddCtrl.getObjet(dataUtiProprio).mGetLib1() + "</b>.</div><br/><br/><div>Un code a été envoyé sur cette adresse email.<br/><br/>Veuillez saisir ce code pour pouvoir utiliser cette adresse email.</div>").appendTo(itemElement)
                        }
                    },
                    adresse_email: dataCompteEmail.adresse_email,
                    inPopup: false,
                    onValide: function () {
                        if (mGetCompteEmail() == null) {
                            jaugeDemarrage.mShow()
                            jaugeDemarrage.option("message", "Recherche des configurations")
                            dxCtrlSaisieCode.remove()
                            option.bddCtrl.mAjaxCall({ command: "getconfigmail", adresse_email: dataCompteEmail.adresse_email }, function (data) {
                                if (typeof data.reception_serveur != 'undefined') {
                                    dataCompteEmail.reception_login = dataCompteEmail.adresse_email
                                    dataCompteEmail.reception_serveur = data.reception_serveur
                                    dataCompteEmail.reception_port = data.reception_port
                                    dataCompteEmail.reception_ssl = data.reception_ssl
                                    dataCompteEmail.reception_is_imap = data.reception_is_imap
                                }
                                if (typeof data.envoi_serveur != 'undefined') {
                                    dataCompteEmail.envoi_login = dataCompteEmail.adresse_email
                                    dataCompteEmail.envoi_serveur = data.envoi_serveur
                                    dataCompteEmail.envoi_port = data.envoi_port
                                    dataCompteEmail.envoi_ssl = data.envoi_ssl
                                }
                                jaugeDemarrage.mHide()
                                dxWizard.mNext(true)
                            }, function () {
                            }, function () {
                                jaugeDemarrage.mHide()
                            });
                        } else {
                            dxWizard.mNext(true)
                            dxCtrlSaisieCode.remove()
                        }
                    }
                })
            }
        }
        wizardItemEmailVerif.getNextItem = function () {
            if (mGetCompteEmail()) {
                //on est sur un mail déjà existant
                return wizardItemDefaut
            } else {
                //on est sur un nouveau mail
                return wizardItemConfigReception
            }
        }
        wizardItemEmailVerif.getPreviousItem = function () { return wizardItemDebut; }
        wizardItemEmailVerif.isOkForNext = function () { return false }

        //Réception
        var dxCtrlCompteEmailConfigReception = null
        var wizardItemConfigReception = new cWizardItem()
        wizardItemConfigReception.itemTemplate = function (itemElement, wizard) {
            $("<div style='font-size:140%;font-weight:bold;'>Configurez la réception de vos emails sur l'adresse <u>" + dataCompteEmail.adresse_email + "</u></div>").appendTo(itemElement)
            $("<div style='font-size:90%;padding-bottom:20px;'><i>Vous pouvez activer la réception de vos messages dans l'application. Dans ce cas là, vous devez saisir les paramètres pour se connecter au serveur.</i></div>").appendTo(itemElement)
            dxCtrlCompteEmailConfigReception = $("<div/>").appendTo(itemElement).dxCtrlCompteEmailConfigReception({
                bddCtrl: option.bddCtrl,
                dataCompteEmail: dataCompteEmail,
                dataCompteEmailUtilisateur: dataCompteEmailUtilisateur,
                allowSave: false,
                jauge: dxWizard.jauge,
                onDemandeClosePopupParent: function () { dxWizard.hide() },
                onDemandeConnexionOauthGmail: function () {
                    mCreateTokenEmailGmail({
                        bddCtrl: option.bddCtrl,
                        onStart: function () {
                            dxWizard.hide()
                        },
                        onValide: function (dataCompteEmail, dataCompteEmailUtilisateur) {
                            mConfirmPopup("<div>Votre adresse email GMAIL a été connecté à l'application.<br/>La fenêtre de configuration de votre adresse va s'afficher.<br/><br/>Voulez-vous activez la réception de vos mails sur ce compte GMAIL immédiatement ?<br/>(Vous pourrez le faire manuellement dans la fenêtre de configuration)</div>", function () {
                                dataCompteEmail.reception_actif = "1";
                                option.bddCtrl.getObjet(dataCompteEmail).mSaveChamp("reception_actif", function (data) {
                                    var opt = { id_utilisateur: dataCompteEmailUtilisateur.id_utilisateur }
                                    option.bddCtrl.getObjet(dataCompteEmail).mShowPopup(opt)
                                })
                            }, "Oui", function () {
                                option.bddCtrl.triggerFunctionOnModifiedItemData("compte_email", "new", dataCompteEmail)
                                var opt = { id_utilisateur: dataCompteEmailUtilisateur.id_utilisateur }
                                option.bddCtrl.getObjet(dataCompteEmail).mShowPopup(opt)
                            }, "Non", function (e) {
                                option.bddCtrl.triggerFunctionOnModifiedItemData("compte_email", "new", dataCompteEmail)
                                var opt = { id_utilisateur: dataCompteEmailUtilisateur.id_utilisateur }
                                option.bddCtrl.getObjet(dataCompteEmail).mShowPopup(opt)
                            })
                        },
                        onCancel: function () {
                            dxCtrlCompteEmailConfigReception.mCancel()
                        }
                    })
                }
            }).dxCtrlCompteEmailConfigReception("instance")
            dxCtrlCompteEmailConfigReception.isConfigOk = false
        }
        wizardItemConfigReception.getNextItem = function () { return wizardItemConfigEnvoi }
        wizardItemConfigReception.getPreviousItem = function () { return wizardItemDebut; }
        wizardItemConfigReception.isOkForNext = function () {
            return true
            //if (dataCompteEmail.envoi_login == null || dataCompteEmail.envoi_login.length == 0) {
            //    dataCompteEmail.envoi_login = dataCompteEmail.reception_login
            //}
            //if (dataCompteEmail.envoi_pwd == null || dataCompteEmail.envoi_pwd.length == 0) {
            //    dataCompteEmail.envoi_pwd = dataCompteEmail.reception_pwd
            //}
            //if (dxCtrlCompteEmailConfigReception.isConfigOk || dataCompteEmail.reception_actif == "0") {
            //    if (dataCompteEmail.reception_actif == "0") {
            //        mNotify("La réception est désactivé. Vous ne recevrez pas vos messages sur cette adresse email.", "warning", 12000)
            //    }
            //    return true
            //} else {
            //    dxCtrlCompteEmailConfigReception.mTestConnexion(function () { dxWizard.mNext() }, function () {
            //        mNotify("Les paramètres de connexion que vous avez saisie sont incorrecte.<br/>Pour continuez, corriger votre configuration ou désactiver la réception.", "error", 12000)
            //    })
            //    return false
            //}
        }

        //Envoi
        var dxCtrlCompteEmailConfigEnvoi = null
        var wizardItemConfigEnvoi = new cWizardItem()
        wizardItemConfigEnvoi.itemTemplate = function (itemElement, wizard) {
            $("<div style='font-size:140%;font-weight:bold;'>Configurez le SMTP de l'adresse email <u>" + dataCompteEmail.adresse_email + "</u> pour l'envoi de vos emails.</div>").appendTo(itemElement)
            $("<div style='font-size:90%;mrgin-bottom:20px;'><i>Vous pouvez activer l'utilisation du SMTP pour l'envoi de vos messages à partir de cette adresse mail. Dans ce cas là, vous devez saisir les paramètres pour se connecter au serveur.</i></div>").appendTo(itemElement)
            //$("<div style='font-size:90%;color:" + theme.toastWarning + ";padding-bottom:20px;'><i>Si vous n'activez pas le SMTP, vous pourrez tout de même envoyer des emails mais la délivrabilité de vos emails ne sera pas optimale.</i></div>").appendTo(itemElement)
            dxCtrlCompteEmailConfigEnvoi = $("<div/>").appendTo(itemElement).dxCtrlCompteEmailConfigEnvoi({
                bddCtrl: option.bddCtrl,
                dataCompteEmail: dataCompteEmail,
                dataCompteEmailUtilisateur: dataCompteEmailUtilisateur,
                allowSave: false,
                jauge: dxWizard.jauge,
                showDelivrabilite: false,
                onDemandeClosePopupParent: function () { dxWizard.hide() },
                onDemandeConnexionOauthGmail: function () {
                    mCreateTokenEmailGmail({
                        bddCtrl: option.bddCtrl,
                        onStart: function () {
                            dxWizard.hide()
                        },
                        onValide: function (dataCompteEmail, dataCompteEmailUtilisateur) {
                            mConfirmPopup("<div>Votre adresse email GMAIL a été connecté à l'application.<br/>La fenêtre de configuration de votre adresse va s'afficher.<br/><br/>Voulez-vous activez la réception de vos mails sur ce compte GMAIL immédiatement ?<br/>(Vous pourrez le faire manuellement dans la fenêtre de configuration)</div>", function () {
                                dataCompteEmail.reception_actif = "1";
                                option.bddCtrl.getObjet(dataCompteEmail).mSaveChamp("reception_actif", function (data) {
                                    var opt = { id_utilisateur: dataCompteEmailUtilisateur.id_utilisateur }
                                    option.bddCtrl.getObjet(dataCompteEmail).mShowPopup(opt)
                                })
                            }, "Oui", function () {
                                option.bddCtrl.triggerFunctionOnModifiedItemData("compte_email", "new", dataCompteEmail)
                                var opt = { id_utilisateur: dataCompteEmailUtilisateur.id_utilisateur }
                                option.bddCtrl.getObjet(dataCompteEmail).mShowPopup(opt)
                            }, "Non", function (e) {
                                option.bddCtrl.triggerFunctionOnModifiedItemData("compte_email", "new", dataCompteEmail)
                                var opt = { id_utilisateur: dataCompteEmailUtilisateur.id_utilisateur }
                                option.bddCtrl.getObjet(dataCompteEmail).mShowPopup(opt)
                            })
                        },
                        onCancel: function () {
                            dxCtrlCompteEmailConfigReception.mCancel()
                        }
                    })
                }
            }).dxCtrlCompteEmailConfigEnvoi("instance")
            dxCtrlCompteEmailConfigEnvoi.isConfigOk = false
        }
        wizardItemConfigEnvoi.getNextItem = function () { return wizardItemDefaut }
        wizardItemConfigEnvoi.getPreviousItem = function () { return wizardItemConfigReception; }
        wizardItemConfigEnvoi.isOkForNext = function () {
            return true
            //if (dxCtrlCompteEmailConfigEnvoi.isConfigOk || dataCompteEmail.envoi_actif == "0") {
            //    //if (dataCompteEmail.envoi_actif == "0") {
            //    //    mNotify("L'utilisation du SMTP de l'adresse email <u>" + dataCompteEmail.adresse_email + "</u> est désactivé. Vos mails seront envoyé via le SMTP de l'application.<br/>ATTENTION, la délivrabilité de vos emails ne sera pas optimale.", "warning", 12000)
            //    //}
            //    return true
            //} else {
            //    dxCtrlCompteEmailConfigEnvoi.mTestConnexion(function () { dxWizard.mNext() }, function () {
            //        mNotify("Les paramètres de connexion que vous avez saisie sont incorrecte.<br/>Pour continuez, corriger votre configuration ou désactiver l'envoi.", "error", 12000)
            //    })
            //    return false
            //}
        }

        //Défaut
        var wizardItemDefaut = new cWizardItem()
        wizardItemDefaut.itemTemplate = function (itemElement, wizard) {
            //if (dxCtrlSignature) {
            //    dxWizard.jauge.mShow()
            //    dxCtrlSignature.mStopSaveAuto(function (base64String) {
            //        dataSignature = base64String
            //        dxWizard.jauge.mHide()
            //    })
            //    dxCtrlSignature = null;
            //}
            $("<div style='font-size:140%;font-weight:bold;padding-bottom:20px;'>Configuration générale <u>" + dataCompteEmail.adresse_email + "</u></div>").appendTo(itemElement)
            $("<div/>").appendTo(itemElement).dxCtrlCompteEmailGeneral({
                bddCtrl: option.bddCtrl,
                dataCompteEmail: dataCompteEmail,
                dataCompteEmailUtilisateur: dataCompteEmailUtilisateur,
                allowSave: false,
                allowSignature: false,
                allowRepAuto: false,
                allowConfidentiel: false,
                allowPartage: false
            })
        }
        wizardItemDefaut.getNextItem = function () { return wizardItemSignature }
        wizardItemDefaut.getPreviousItem = function () {
            if (isAbonnement) {
                return wizardItemDebut;
            } else {
                return wizardItemConfigEnvoi;
            }
        }
        wizardItemDefaut.isOkForNext = function () { return true }

        //signature
        var dxCtrlSignature = null
        var dataSignature = null
        var wizardItemSignature = new cWizardItem()
        wizardItemSignature.allowScroll = false
        wizardItemSignature.itemTemplate = function (itemElement, wizard) {
            itemElement.css({
                "display": "flex",
                "align-items": "center",
                "justify-content": "center",
                "text-align": "center"
            })
            var $Div = $("<div/>").appendTo(itemElement)
            dxCtrlSignature = $("<div/>").appendTo(itemElement).dxCtrlEmailData({
                bddCtrl: option.bddCtrl,
                value: dataSignature,
                allowCorbeille: false,
                allowDuplik: false,
                rempliTxtLib: function (contentElement, value) {
                    var txtLib = ""
                    if (value == null || value.length == 0) {
                        txtLib = "<div style='color:" + theme.toastWarning + ";font-size:16px;'>(aucune signature spécifique pour cette adresse)</div>"
                        if (option.bddCtrl.utiCourant.data_signature == null || option.bddCtrl.utiCourant.data_signature.length == 0) {
                            txtLib += "<div style='font-size:90%;'>Vous pouvez définir la signature ici uniquement pour ce mail ou dans le profil utilisateur (dans ce cas, la signature s'appliquera à toutes les adresses sans signature).</div>"
                        } else {
                            txtLib += "<div style='font-size:90%;'>La signature qui sera utilisé est celle qui est défini au niveau de la configuration utilisateur (dans le profil utilisateur).</div>"
                        }
                    } else {
                        txtLib = "<div style='color:" + theme.toastSuccess + ";font-size:16px;'>Signature spécifique active pour cette adresse</div>"
                        txtLib += "<div style='font-size:90%;'>Cette signature est spécifique à cette adresse email.</div>"
                    }
                    contentElement.html(txtLib)
                },
                onValueChanged: function (value) {
                    dataSignature = value
                }
            }).dxCtrlEmailData("instance")
            //}
        }
        wizardItemSignature.getNextItem = function () { return wizardItemFin }
        wizardItemSignature.getPreviousItem = function () { return wizardItemDefaut; }
        wizardItemSignature.isOkForNext = function () { return true }


        var wizardItemFin = new cWizardItem()
        wizardItemFin.allowScroll = false
        wizardItemFin.itemTemplate = function (itemElement, wizard) {
            //if (dxCtrlSignature) {
            //    dxWizard.jauge.mShow()
            //    dxCtrlSignature.mStopSaveAuto(function (base64String) {
            //        dataSignature = base64String
            //        dxWizard.jauge.mHide()
            //    })
            //    dxCtrlSignature = null;
            //}
            itemElement.css({
                "display": "flex",
                "align-items": "center",
                "justify-content": "center",
                "text-align": "center"
            })
            var $Div = $("<div/>").appendTo(itemElement)
            if (dataCompteEmail.id_utilisateur == dataCompteEmailUtilisateur.id_utilisateur) {
                txt = "Votre adresse email est prête à être intégré dans votre base de données.<br/><br/>" +
                    "Dès que vous l'aurez validée, la réception et l'envoi de mail sera disponible sur cette adresse.<br/>"
                $("<div>" + txt + "</div>").appendTo($Div)
                $("<br/>").appendTo($Div)
                $("<div/>").appendTo($Div).dxCtrlButton({
                    text: "Créer l'adresse email dans la base de données",
                    onClick: function (e) { mSaveAndClose() }
                });
            } else {
                txt = "Vous êtes prêt à être abonné à l'adresse email.<br/><br/>" +
                    "Après validation, le mail sera rajouté à votre compte.<br/>"
                $("<div>" + txt + "</div>").appendTo($Div)
                $("<br/>").appendTo($Div)
                $("<div/>").appendTo($Div).dxCtrlButton({
                    text: "M'abonner à l'adresse email",
                    onClick: function (e) { mSaveAndClose() }
                });
            }
        }
        wizardItemFin.getNextItem = function () { return null }
        wizardItemFin.getPreviousItem = function () { return wizardItemSignature; }
        wizardItemFin.isOkForNext = function () { return true }


        dxWizard = container.appendTo("body").dxCtrlWizard({
            bddCtrl: option.bddCtrl,
            dataSource: [wizardItemDebut, wizardItemEmailVerif, wizardItemConfigReception, wizardItemConfigEnvoi, wizardItemDefaut, wizardItemSignature, wizardItemFin],
            title: ((typeof option.title == 'undefined') ? "Ajouter une adresse email" : option.title),
            onClickClose: function (target) {
                if (passFirstItem) {
                    var tt = $("<div/>").appendTo("body").dxCtrlTooltip({
                        target: target,
                        contentTemplate: function (contentElement) {
                            contentElement.css("padding", "24px");
                            $("<div style='padding-bottom:15px'>L'adresse email ne sera pas sauvegardé</div>").appendTo(contentElement)
                            $("<div/>").appendTo(contentElement).dxCtrlButton({
                                text: "confirmer",
                                onClick: function (e) {
                                    dxWizard.hide();
                                    tt.hide()
                                }
                            });
                        }
                    }).dxCtrlTooltip("instance");
                    tt.show()
                    return false
                } else { return true; }
            },
            onValidate: function () { mSaveAndClose() }
        }).dxCtrlWizard("instance")

        function mSaveAndClose() {
            jaugeDemarrage.mShow()
            if (dataSignature != null) {
                if (option.bddCtrl.getObjet(option.bddCtrl.utiCourant).objetMetier.mGetLstDataCompteEmail().length == 0) {
                    //on a aucun compte mail
                    if (option.bddCtrl.utiCourant.data_signature == null || option.bddCtrl.utiCourant.data_signature.length == 0) {
                        //on copy en signature générique de l'utilisateur car on en pas
                        option.bddCtrl.utiCourant.data_signature = dataSignature
                        option.bddCtrl.getObjet(option.bddCtrl.utiCourant).mSave(function (data) {
                            mSave()
                        })
                    } else {
                        //on a une signature générique //on met la signature sur l'adresse email
                        dataCompteEmailUtilisateur.data_signature = dataSignature
                        mSave()
                    }
                } else {
                    dataCompteEmailUtilisateur.data_signature = dataSignature
                    mSave()
                }
            } else { mSave() }

            //function mValideByCode() {
            //    if (dataCompteEmail.id_utilisateur == dataCompteEmailUtilisateur.id_utilisateur) {
            //        //on crée une nouvelle adresse email
            //        //le pop n'est pas défini
            //        //on demande une confirmation
            //        jaugeDemarrage.mHide()
            //        $("<div/>").appendTo(container).dxCtrlSaisieCode({
            //            bddCtrl: option.bddCtrl,
            //            title: "Confirmez votre email",
            //            adresse_email: dataCompteEmail.adresse_email,
            //            onValide: function () {
            //                jaugeDemarrage.mShow()
            //                mSave()
            //            },
            //            onCancel: function () {

            //            }
            //        })
            //    } else {
            //        mSave()
            //    }
            //}

            function mSave() {
                if (isAbonnement) {
                    dataCompteEmailUtilisateur.id_compte_email = dataCompteEmail.id_compte_email
                    option.bddCtrl.getObjet(dataCompteEmailUtilisateur).mSave()
                    dxWizard.hide()
                    jaugeDemarrage.mHide()
                } else {
                    option.bddCtrl.getObjet(dataCompteEmail).mSave(function () {
                        dataCompteEmailUtilisateur.id_compte_email = dataCompteEmail.id_compte_email
                        option.bddCtrl.getObjet(dataCompteEmailUtilisateur).mSave()
                        dxWizard.hide()
                        jaugeDemarrage.mHide()
                    })
                }

            }
        }
    }

    this.element = function () { return container; }
    this.component = function () { return dx; }

    mConstruit();
}